import { render, staticRenderFns } from "./PixDialog.vue?vue&type=template&id=2cc0f7c6&scoped=true"
import script from "./PixDialog.vue?vue&type=script&lang=js"
export * from "./PixDialog.vue?vue&type=script&lang=js"
import style0 from "./PixDialog.vue?vue&type=style&index=0&id=2cc0f7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0f7c6",
  null
  
)

export default component.exports